import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(1 1)",
			strokeWidth: 2,
			children: [/* @__PURE__ */ _jsx("circle", {
				strokeOpacity: .5,
				cx: 18,
				cy: 18,
				r: 18
			}), /* @__PURE__ */ _jsx("path", {
				d: "M36 18c0-9.94-8.06-18-18-18",
				children: /* @__PURE__ */ _jsx("animateTransform", {
					attributeName: "transform",
					type: "rotate",
					from: "0 18 18",
					to: "360 18 18",
					dur: "1s",
					repeatCount: "indefinite"
				})
			})]
		})
	})
});
export default SvgSpinner;
